module.exports = __webpack_public_path__ + "static/img/payment_logo.0b38a18.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/common/payment_logo.png
// module id = WSBW
// module chunks = 0